var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"end-node"},[_c('div',{staticClass:"end-node-circle"}),_c('div',{staticClass:"end-node-text"},[_vm._v(" "+_vm._s(_vm.node.name))])])
}
var staticRenderFns = []

export { render, staticRenderFns }